module.exports = __webpack_public_path__ + "media/images/advisers/img_yoshida-2b4c2703c7030c4339644adfdab45e79.jpg";